<template src="./edit-vertical.component.html"></template>
<style scoped src="./edit-vertical.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import Sidebar from '@/components/sidebar/sidebar.component.vue';
import api from '@/api';
import {Vertical} from '@/models';

export default Vue.extend({
  name: 'EditVertical',
  components: {
    Sidebar,
  },
  data() {
    return {
      msg: `Edit Vertical - ${this.$route.params.id}`,
      vertical: null as Vertical | null,
      hidden: true,
      name: '',
    };
  },
  async created() {
    this.vertical = await api.execute('get', `/verticals/${this.$route.params.id}`) as Vertical;
    this.name = this.vertical.name;
  },
  mounted() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  destroyed() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  methods: {
    async updateVertical() {
      if (!this.vertical) return;
      const response = await api.execute('put', `/verticals/${this.vertical.id}`, {
        name: this.name,
      });
      if (response === 500) {
        this.hidden = false;
      } else {
        this.hidden = true;
        alert('Vertical updated correctly');
      }
    },
  },
});
</script>
